<template>
  <div class="container">
    <!-- 导航 -->
    <Nav @loadingShowClick="loadingShowClick"></Nav>
    <!-- 联系客服和返回顶部 -->
    <BackTop></BackTop>
    <!-- <keep-allive> -->
      <router-view />
    <!-- </keep-allive> -->
    <!-- 底栏 -->
    <Footer></Footer>
    <div v-show="loadingShow" class="loadingMask">
      <van-loading type="spinner" color="orange" />
    </div>
  </div>
</template>

<script>

// 引入所有页面的公用组件
    // 引入nav组件
import Nav from '@/components/nav/nav';
    // 引入footer组件
import Footer from '@/components/footer/footer';
// 引入返回顶部，联系客服组件
import BackTop from '@/components/backTop/index';


export default {
  name: 'Layout',
  components: {
    Nav,
    Footer,
    BackTop
  },
  data(){
    return {
      loadingShow:false
    }
  },
  methods: {
    loadingShowClick(bool){
      this.loadingShow = bool;
      setTimeout(()=>{
        this.loadingShow = false;
      },1500)
    }
  },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
 *{
    margin:0;
    padding:0;
    box-sizing: border-box;
 }
 .container{
    width:100%;
    height:100%;
    /* position: relative; */
    overflow-x: hidden;
 }
 /* 中英文切换时的loading蒙层 */
.loadingMask{
    width:100vw;height:100vh;
    position: fixed;
    left:0;top:0;
    background-color: rgba(0,0,0,0.5);
    z-index:999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue